import { TruncatedTooltip } from '@common/components/TruncatedTooltip';
import { Checkbox, Flex, Grid, ScrollArea, Text } from '@radix-ui/themes';
import { DeliveryItem } from '../types';
import { ReactNode } from 'react';

interface Props<T extends DeliveryItem> {
    items: T[];
    selectedIds: number[];
    onToggle: (id: number) => void;
    label: string;
    renderItem?: (item: T) => ReactNode;
}

export const DeliveryItemList = <T extends DeliveryItem>({
    items,
    selectedIds,
    onToggle,
    label,
    renderItem,
}: Props<T>) => (
    <Flex direction='column' gap='2' flexGrow={'1'} width={'100%'} px={'1'}>
        <Text size='2' weight='bold' color='gray'>
            {label} ({selectedIds.length}/{items.length})
        </Text>

        <ScrollArea
            type='auto'
            scrollbars='vertical'
            style={{
                maxHeight: '150px',
                border: '1px solid var(--gray-5)',
                borderRadius: 'var(--radius-2)',
            }}
        >
            <Flex direction='column' gap='2' p='3'>
                {items.map((item) => (
                    <Text key={item.id} as='label' size='2'>
                        <Grid
                            columns={'auto 1fr'}
                            gap={'2'}
                            align={'center'}
                            width={'100%'}
                            style={{ cursor: 'pointer' }}
                        >
                            <Checkbox
                                checked={selectedIds.includes(item.id)}
                                onCheckedChange={() => onToggle(item.id)}
                            />

                            {renderItem ? (
                                renderItem(item)
                            ) : (
                                <TruncatedTooltip minWidth='0'>
                                    {item.name}
                                </TruncatedTooltip>
                            )}
                        </Grid>
                    </Text>
                ))}
            </Flex>
        </ScrollArea>
    </Flex>
);
